<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <WorkExtraTypeTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkExtraTypeTableItem from 'components/setting/workExtraType/WorkExtraTypeTableItem'
export default {
  name: 'WorkExtraTypeTable',
  props: ['items'],
  components: { WorkExtraTypeTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-work_extra_type']['tables'][
            'vidy-dopolnitelnyh-rabot'
          ],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
